import { useRouter } from 'next/router'
import { useEffect } from 'react'

import { setRouterInstance } from '../store/usePersistentObservatoryPageStore'

/**
 * Component that initializes the router instance for the observatory page store
 * This allows the store to use the router outside of React components
 */
export const RouterInitializer = () => {
  const router = useRouter()

  useEffect(() => {
    // Store the router instance in the store
    // This allows the store to use the router outside of React components
    setRouterInstance(router)
  }, [router])

  // This component doesn't render anything
  return null
}
